export default "__VITE_ASSET__aIbLJoQ$__"